import { useContext } from 'react'
import { useFormikContext, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import classnames from 'classnames/bind'
import { addDays, addMinutes, clamp, roundToNearestMinutes, setHours, setMinutes, setSeconds } from 'date-fns'
import { motion, AnimatePresence } from "framer-motion"
import { InputField, CheckboxField, FormContent, FormHeader, ButtonDrawer, FormError, DatePicker, TimePicker, PackageBookingSummary } from '~/components'
import { StepperContext } from '~/components/ui/ViewStepper'
import { wrapWithValidation } from '~/utils'
import * as common from '~/config/common.module.css'
import * as styles from './index.module.css'
import * as MotionElement from '~/components/ui/MotionElement'
import { useTranslation } from 'react-i18next'
import i18next from '~/i18n'

const cx = classnames.bind(common)

const getMinDate = () => addMinutes(setSeconds(roundToNearestMinutes(new Date(), { nearestTo: 5 }), 0), 30)
const getMaxDate = () => addDays(setHours(setMinutes(setSeconds(new Date(), 0), 59), 23), 27)

const SelectTime = ({fullscreen, currentView}) => {
  const { t } = useTranslation()
  const { prev, next } = useContext(StepperContext)
  const wrappedNext = wrapWithValidation(next, useFormikContext())

  const { values, setFieldValue } = useFormikContext()
  const inEditMode = !isNaN(values.bookingId) && values.bookingId > 0

  const minDate = getMinDate()
  const maxDate = getMaxDate()
  const clampDate = date => clamp(date, { start: minDate, end: maxDate })

  const goNow = () => {
    setFieldValue('pickupTime', '', false)
    next()
  }

  const buttons = [
    { func: prev, isBack: true },
    { func: goNow, title: t('button-book-delivery-now') },
    { func: wrappedNext, title: t('button-continue') }, 
  ]

  return (
      <div className={cx(common.widgetWrapper, { fullscreen })}>
        <FormContent>
          <FormHeader onlyFullscreen>{inEditMode ? t('edit-your-trip') : t('your-trip')}</FormHeader>
          <FormHeader onlyMobile>{t('header-when-should-we-pickup')}</FormHeader>
          <PackageBookingSummary values={values} showTime currentView={currentView}/>
        </FormContent>
        <div className={common.contentBottom}>
          <FormHeader onlyFullscreen>{t('header-when-should-we-pickup')}</FormHeader>
          <MotionElement.div className={common.content}>
            <div>
              <div className={styles.datepicker}>
                <Field name="pickupTime" minDate={minDate} maxDate={maxDate} clampDate={clampDate} component={DatePicker} />
              </div>
              <ErrorMessage name="pickupTime" component={FormError} />
            </div>
            <div className={common.group}>
              <Field name="pickupTime" minDate={minDate} maxDate={maxDate} clampDate={clampDate} component={TimePicker} />
            </div>
          </MotionElement.div>
        </div>
        <ButtonDrawer buttons={buttons} fullscreen={fullscreen}/>
      </div>
  )
}

SelectTime.validationSchema = Yup.object({
  pickupTime: Yup.date()
    .min(getMinDate(), i18next.t('validation-date-not-valid'))
    .max(getMaxDate(), i18next.t('validation-date-too-far-ahead'))
    .required(i18next.t('validation-need-date')),
})

export default SelectTime
